import { RadialWheel } from './radialwheel';

// HOLD-E on a keypad lock you own opens this 3-option wheel: set/change the code, remove the code (which unlocks
// the door -> green light), or take the whole keypad lock back off the door. It's a RadialWheel subclass, so it
// inherits the first-person movement-cursor selection for free. main captures the aimed door when it opens and
// applies the pick to that door.
export type KeypadAction = 'change' | 'clearcode' | 'removelock';

export class KeypadWheel extends RadialWheel<KeypadAction, never> {
  onPick: ((a: KeypadAction) => void) | null = null;

  constructor() {
    super({
      segments: [
        { key: 'change', label: 'Change\nCode' },
        { key: 'clearcode', label: 'Remove\nCode' },
        { key: 'removelock', label: 'Remove\nLock' },
      ],
      activeSeg: null,
      hubFallbackLabel: 'KEYPAD',
      onPointerCommit: () => this.commitSelection(),
    });
  }

  // Apply the hovered action + close. Also called on E-release (release-to-select).
  commitSelection(): void { this.commit({ onSeg: (a) => { this.onPick?.(a); this.hide(); }, stickySeg: false }); }
}
